import { useCallback, useState } from 'react'

const useToggle = (initialState = false): [boolean, any, any] => {
  const [state, setState] = useState<boolean>(initialState)
  const toggle = useCallback((): void => setState((state) => !state), [])
  return [state, toggle, setState]
}

export default useToggle
